export enum RemoteConfigValueType {
  STRING = 'STRING',
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  JSON = 'JSON'
}
